import { Injectable, inject } from "@angular/core";
import { Query, ResolverParams, ResolverService } from "./api/resolver.service";
import { KFeathers } from "./api/feathers.service";
import * as _ from "lodash-es";
import { Customer, ICustomer } from "../models/customer.model";
import { Contact } from "../models/customer-contact";
import { L2PUBProject } from "../models/projects/submodels/l2pub-project.model";
import { IRiverflowJobType, RiverflowJobType } from "../models/riverflow/riverflow-job-types.model";


@Injectable({ providedIn: 'root' })
export class RiverflowJobTypeService extends ResolverService<RiverflowJobType> {
    protected feather: KFeathers;

    path: string = 'riverflow/job-types';
    model: new (any: any) => RiverflowJobType = RiverflowJobType;

    constructor() {
        const feather = inject(KFeathers);

        super(feather);
    
        this.feather = feather;
    }

}